import { render, staticRenderFns } from "./EqualOrGreaterErrorMessage.vue?vue&type=template&id=38de7c34&"
import script from "./EqualOrGreaterErrorMessage.vue?vue&type=script&lang=js&"
export * from "./EqualOrGreaterErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38de7c34')) {
      api.createRecord('38de7c34', component.options)
    } else {
      api.reload('38de7c34', component.options)
    }
    module.hot.accept("./EqualOrGreaterErrorMessage.vue?vue&type=template&id=38de7c34&", function () {
      api.rerender('38de7c34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Errors/EqualOrGreaterErrorMessage.vue"
export default component.exports